import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useNotifications } from '../../notifications/use-notifications'
import { useProjects } from '../../project/use-projects'
import { FormValues, ProjectDialog } from '../project/ProjectDialog'

export function CreateNewProject(): React.ReactElement {
  const [open, setOpen] = useState(false)
  const { enqueueInfo, enqueueSuccess, enqueueError, closeSnackbar } =
    useNotifications()
  const { createProject } = useProjects()
  const { t } = useTranslation()
  const history = useHistory()

  const onSubmit = async (values: FormValues) => {
    const infoKey = enqueueInfo(t('projects.createInfo'))

    try {
      const project = await createProject({
        projectId: values.projectId,
        name: values.name,
        versionName: values.versionName,
        calendarYear: Number(values.calendarYear),
      })

      enqueueSuccess(t('projects.createSuccess'))
      setOpen(false)
      history.push(`/projects/${project.id}`)
    } catch (e) {
      enqueueError(t('projects.createError'))
    }

    closeSnackbar(infoKey)
  }

  return (
    <>
      <Button
        id="create-new-project"
        data-testid="create-new-project"
        variant="contained"
        color="primary"
        onClick={() => setOpen(!open)}
      >
        {t('projects.createNew')}
      </Button>

      <ProjectDialog
        isOpen={open}
        onSubmit={onSubmit}
        onClose={() => setOpen(false)}
      />
    </>
  )
}
